//PARROQUIAS Anzoategui
const munAnaco = ['Anaco Anaco', 'San Joaquín', 'Buena Vista'];
const munAragua = ['Aragua', 'Cachipo'];
const munFernandoPenalver = [
  'Fernando de Peñalver Puerto Píritu',
  'San Miguel',
  'Sucre',
];
const munFranciscoCarmen = [
  'Francisco del Carmen Carvajal Valle de Guanape',
  'Santa Bárbara Santa Bárbara',
];

const munFranciscoMiranda = [
  'Francisco de Miranda Pariaguán',
  'Atapirire',
  'Boca del Pao Boca del Pao',
  'El Pao',
  'Múcura',
];

const munGuanta = ['Chorrerón', 'Guanta'];
const munIndependencia = ['Independencia', 'Mamo'];
const munJuanAntonioSotillo = ['Puerto La Cruz', 'Pozuelos'];
const munJuanManuelCajigal = [
  'Juan Manuel Cajigal Onoto',
  'San Pablo San Pablo',
];
const munJoseGregorioMonagas = [
  'José Gregorio Monagas Mapire',
  'Piar',
  'San Diego de Cabrutica San Diego de Cabrutica',
  'Santa Clara',
  'Uverito',
  'Zuata',
];
const munLibertad = ['Santa Inés', 'El Carito', 'Libertad'];
const munManuelEzequielBruzual = [
  'Manuel Ezequiel Bruzual',
  'Guanape',
  'Sabana de Uchire',
];

const munPedroMariaFreites = [
  'Pedro María Fréites',
  'Libertador',
  'Santa Rosa',
  'Urica',
];

const munPiritu = ['San Francisco', 'Capital Píritu'];

const munSanJuanCapistrano = ['Boca de Chávez', 'San Juan de Capistrano'];
const munSanJoseGuanipa = [];

const munSimonBolivar = [
  'El Carmen',
  'San Cristóbal',
  'Bergantín',
  'Caigua',
  'El Pilar',
  'Naricual',
];
const munSantaAna = ['Santa Ana', 'Pueblo Nuevo'];

const munSirArthurMcGregor = ['Sir Arthur Mc Gregor', 'Tomás Alfaro Calatrava'];
const munSimonRodriguez = ['Edmundo Barrios', 'Miguel Otero Silva'];
const munDiegoBautistaUrbaneja = ['Diego Bautista Urbaneja', 'El Morro'];

export const esAnzoategui = [
  {
    municipio: 'Anaco',
    parroquias: munAnaco,
  },
  {
    municipio: 'Aragua',
    parroquias: munAragua,
  },
  {
    municipio: 'Municipio Fernando de Peñalver',
    parroquias: munFernandoPenalver,
  },
  {
    municipio: 'Francisco del Carmen Carvajal Valle de Guanape',
    parroquias: munFranciscoCarmen,
  },
  {
    municipio: 'Francisco de Miranda',
    parroquias: munFranciscoMiranda,
  },
  {
    municipio: 'Guanta',
    parroquias: munGuanta,
  },
  {
    municipio: 'Independencia',
    parroquias: munIndependencia,
  },
  {
    municipio: 'Juan Antonio Sotillo',
    parroquias: munJuanAntonioSotillo,
  },
  {
    municipio: 'Juan Manuel Cajigal',
    parroquias: munJuanManuelCajigal,
  },
  {
    municipio: 'José Gregorio Monagas',
    parroquias: munJoseGregorioMonagas,
  },
  {
    municipio: 'Libertad',
    parroquias: munLibertad,
  },
  {
    municipio: 'Manuel Ezequiel Bruzual',
    parroquias: munManuelEzequielBruzual,
  },
  {
    municipio: 'Pedro María Fréites',
    parroquias: munPedroMariaFreites,
  },
  {
    municipio: 'Píritu',
    parroquias: munPiritu,
  },
  {
    municipio: 'San Jose de Guanipa',
    parroquias: munSanJoseGuanipa,
  },
  {
    municipio: 'San Juan de Capistrano',
    parroquias: munSanJuanCapistrano,
  },
  {
    municipio: 'Santa Ana',
    parroquias: munSantaAna,
  },
  {
    municipio: 'Simón Bolívar',
    parroquias: munSimonBolivar,
  },
  {
    municipio: 'Simón Rodríguez',
    parroquias: munSimonRodriguez,
  },
  {
    municipio: 'Sir Arthur Mc Gregor',
    parroquias: munSirArthurMcGregor,
  },
  {
    municipio: 'Diego Bautista Urbaneja',
    parroquias: munDiegoBautistaUrbaneja,
  },
];
